export function Loading() {
  return <h2>🌀 Chargement en cours</h2>;
}
